<template>
  <TransactionList v-bind="$props" />
</template>

<script>
import TransactionList from '@/components/TransactionList';

export default {
  name: 'TransactionsTab',

  components: {
    TransactionList,
  },

  props: [
    /* eslint-disable vue/prop-name-casing, vue/require-prop-types */
    'distributor_id',
    'subdistributor_id',
    'chain_id',
    'store_id',
  ],
};
</script>
